<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Edit State"></app-page-title>
        <form [formGroup]="stateform">
            <div class="row">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="country" class="form-label">Country<span
                                            class="mandatory">*</span></label>
                                    <ng-select #country id="country" placeholder="Select" [items]="countryList"
                                        bindLabel="name" [bindValue]="'isocode'" [appendTo]="'body'"
                                        [openOnEnter]="false" formControlName="ddlCountry"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || stateform.get('ddlCountry').touched) && stateform.get('ddlCountry').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || stateform.get('ddlCountry').touched) && stateform.get('ddlCountry').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="stateform.get('ddlCountry').errors.required">Country is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="statecode" class="form-label">Code <span
                                            class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="statecode"
                                        maxlength="3" formControlName="txtStateCode"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || stateform.get('txtStateCode').touched) && stateform.get('txtStateCode').errors}">
                                    <div *ngIf="(isFormSubmitted || stateform.get('txtStateCode').touched) && stateform.get('txtStateCode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="stateform.get('txtStateCode').errors.required">Code is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="statename" class="form-label">Name <span
                                            class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="statename"
                                        maxlength="70" formControlName="txtStateName"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || stateform.get('txtStateName').touched) && stateform.get('txtStateName').errors}">
                                    <div *ngIf="(isFormSubmitted || stateform.get('txtStateName').touched) && stateform.get('txtStateName').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="stateform.get('txtStateName').errors.required">Name is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="gstalice" class="form-label">GST Alise </label>
                                    <input type="text" class="form-control form-control-sm" id="gstalice"
                                        formControlName="txtGstAlise"  maxlength="5"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || stateform.get('txtGstAlise').touched) && stateform.get('txtGstAlise').errors}">
                                </div>
                            </div>
                            <div class="col-md-1" style="margin-left: 50px;">
                                <div class="mb-2">
                                    <label for="status" class="form-label">Status</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="txtStatus">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="button" class="btn btn-primary w-sm" (click)="updateState()">Update</button>
                        <a routerLink="/setup/geo/states"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>